import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
//安装插件
Vue.use(Vuex)
//创建对象
const store = new Vuex.Store({
   modules: {
     common:user,
   }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js